import CompanyApi from '@/api/CompanyApi';
import CompanyLogoApiAgency from '@/api/CompanyLogoApiAgency';
import type OrganizationCompanyListItemEntity from '@/entity/organization-company/OrganizationCompanyListItemEntity';
import { useModal } from '@orion.ui/orion';
import { defineAsyncComponent } from 'vue';
import useUiService from '../UiService';

class CompanyService {

	private companyEntity?: OrganizationCompanyListItemEntity;

	constructor (companyEntity?: OrganizationCompanyListItemEntity) {
		this.companyEntity = companyEntity;
	}

	async promptLogoModalAsync (companyId: number, companyLogoId?: number) {
		useModal({
			Nested: defineAsyncComponent(() => import('@/components/shared/SharedLogoCompanyModal.vue')),
			NestedProps: {
				companyId,
				companyLogoId,
				companyEntity: this.companyEntity,
			},
			size: 'sm',
		});
	}

	async addLogoAsync (...payload: Parameters<typeof CompanyLogoApiAgency.add>) {
		const { data } = await CompanyLogoApiAgency.add(...payload);
		if (this.companyEntity) this.companyEntity.setLogo(data);
		useUiService().update();
	}

	async updateLogoAsync (...payload: Parameters<typeof CompanyLogoApiAgency.update>) {
		await CompanyLogoApiAgency.update(...payload);
		useUiService().update();
	}

	async deleteLogoAsync (logoId: number) {
		await CompanyLogoApiAgency.delete(logoId);
		if (this.companyEntity) this.companyEntity.deleteLogo();
		useUiService().update();
	}

	async getDetailedAsync (...args: Parameters<typeof CompanyApi.getDetailed>) {
		const { data } = await CompanyApi.getDetailed(...args);
		return data;
	}

	async getAsync (...args: Parameters<typeof CompanyApi.get>) {
		const { data } = await CompanyApi.get(...args);
		return data;
	}

	async getForPaymentDemandAsync () {
		const { data } = await CompanyApi.getForPaymentDemand();
		return data;
	}

	async getAvailableForOrganizationAsync (...args: Parameters<typeof CompanyApi.getAvailableForOrganization>) {
		const { data } = await CompanyApi.getAvailableForOrganization(...args);
		return data;
	}

	async getCompaniesWithMembershipsByUserIdAsync (...args: Parameters<typeof CompanyApi.getCompaniesWithMembershipsByUserId>) {
		const { data } = await CompanyApi.getCompaniesWithMembershipsByUserId(...args);
		return data;
	}

}

export function useCompanyService (companyEntity?: OrganizationCompanyListItemEntity) {
	return new CompanyService(companyEntity);
}
